export default __webpack_public_path__ + "static/media/arrow_line.25e93149.svg";